import Router from 'next/router';
import notificationsActions from '../../store/actions/notificationsActions';

// eslint-disable-next-line import/prefer-default-export
export const onNotificationClick = (notification, dispatch, token) => {
  if (!notification.read) {
    dispatch(notificationsActions.readNotification(token, notification.id));
  }

  if (notification.type === 'order' && notification?.replace?.order_link) {
    Router.push({ pathname: '/cabinet/deals', query: { order: notification.replace.order_link }, shallow: true });
  }

  if (notification.type === 'product_message' && notification?.replace?.chat_id) {
    Router.push({ pathname: '/cabinet/profile', query: { page: 'questions', chat: notification.replace.chat_id }, shallow: true });
  }

  if (notification.type === 'chat' && notification?.replace?.order_link) {
    Router.push({ pathname: '/cabinet/deals', query: { order: notification.replace.order_link }, shallow: true });
  }
};
